import React, { useEffect, useMemo, useRef, useState } from 'react';
import { IoClose } from "react-icons/io5";
import { BrowserView, isMobile, isTablet } from 'react-device-detect';
import { fmesh, foundFeature, fmeshPoints } from '../../core/globalVariables.js';
import Drawer from 'react-modern-drawer';
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import Chart from "chart.js/auto";
import { MdOutlineAddToPhotos } from "react-icons/md";
import { CgMenuGridO } from "react-icons/cg";
import { MdOutlineLayers } from "react-icons/md";
import ClickedInfoRealm from "./../menus/leftMenuComponents/clickedInfoRealm.js";
import MetricItem from "../menus/leftMenuComponents/MetricItem.js";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosClose } from "react-icons/io";
import { Tb3DCubeSphere } from 'react-icons/tb';
import { BiSolidColor } from "react-icons/bi";
import ValueDropdown from '../../ui/menus/leftMenuComponents/ValueDropdown.js'
import KeyDropdown from '../../ui/menus/leftMenuComponents/keyDropdown.js';
import YearDropdown from '../../ui/menus/leftMenuComponents/yearDropdown.js';
import fetchMetricDataSummaryKey from '../../dataManagement/fetchMetricDataSummaryKey.js';
import fetchMetricDataSummaryNumeric from '../../dataManagement/fetchMetricDataSummaryNumeric.js'
import { IoIosInformationCircleOutline } from "react-icons/io";
import { MdBarChart } from "react-icons/md";
import { FaRegFileImage } from "react-icons/fa";
import { CgNotes } from "react-icons/cg";
import { IoFilter } from "react-icons/io5";
import MapMetaOrFeatureDataSimple from "../menus/leftMenuComponents/MapMetaOrFeatureDataSimple.js";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const ClickedInfo = ({
  isVisible,
  polygonCustomLayerRef,
  clickedInfoHeader,
  globalState,
  globalRefs,
  longstandingGeoJSONRef,
  originalGeoJSONforComparingRef,
  ResetMap,
}) => {
  const [modalOtherOriginal, setmodalOtherOriginal] = useState(null);
  const [modalOtherAmended, setmodalOtherAmended] = useState(null);
  const [modalSkylarkId, setModalSkylarkId] = useState(null);
  const [selectedMetricValue, setSelectedMetricValue] = useState(null);
  const [selectedKeyValue, setSelectedKeyValue] = useState(null);
  const [landKeySelectedKeyColourOriginal, setlandKeySelectedKeyColourOriginal] = useState(null);
  const [landKeySelectedKeyColourAmended, setlandKeySelectedKeyColourAmended] = useState(null);
  const [totalSumMetric, setTotalSumMetric] = useState(0);
  const [totalSumMetricOriginal, setTotalSumMetricOriginal] = useState(0);
  const [totalSumsValue, setTotalSumsValue] = useState(null);
  const [totalSumsValueOriginal, setTotalSumsValueOriginal] = useState(null);
  const [multilayerDetails, setMultilayerDetails] = useState('');
  const [multilayerOriginalGroupDetails, setMultilayerOriginalGroupDetails] = useState('');
  const [multiGroupDetails, setMultilayerGroupDetails] = useState('');
  const [multilayerOriginalParcelDetails, setMultilayerOriginalParcelDetails] = useState('');
  const [multiParcelDetails, setMultilayerParcelDetails] = useState('');
  const [valuesFromGroupData, setValuesFromGroupData] = useState('');
  const [moreThanOneLayer, setMoreThenOneLayer] = useState(false);
  const [moreThanOnePolygonSelected, setMoreThenOnePolygonSelected] = useState(false);
  const [numericAggregationMethod, setNumericAggregationMethod] = useState("sum");
  const totalLineChartRef = useRef(null);
  let noData = true;

  const setSelectedMetric = globalState.setSelectedMetric;
  const selectedKey = globalState.selectedKey;
  const setSelectedKey = globalState.setSelectedKey;
  const universalDataLoaded = globalState.universalDataLoaded;
  const isModifying = globalState.isModifying;
  const TotalsRef = globalRefs.TotalsRef;
  const currentMapIdRef = globalRefs.currentMapIdRef;
  const yearsAvailable = globalState.yearsAvailable;
  let availableDates = globalState.availableDates;
  let setAvailableDates = globalState.setAvailableDates;
  const setSelectedYearEditing = globalState.setSelectedYearEditing;
  let selectedRange = globalState.selectedRange;
  let setSelectedRange = globalState.setSelectedRange;
  let selectedYearEditing = globalState.selectedYearEditing;
  let setIsVisible = globalState.setIsVisible;
  let selectedMetric = globalState.selectedMetric;
  let landKeySelectedKey = globalState.landKeySelectedKey;
  let setLayers = globalState.setLayers;
  let hasChangedKeyValue = globalState.hasChangedKeyValue;
  let multiLayerSelected = globalState.multiLayerSelected;
  let setMultiLayerSelected = globalState.setMultiLayerSelected;
  let multuLayerSelectedArray = globalState.multuLayerSelectedArray;
  let setMultuLayerSelectedArray = globalState.setMultuLayerSelectedArray;
  let greoupingSelected = globalState.greoupingSelected;
  let setGreoupingSelected = globalState.setGreoupingSelected;
  let multuGroupSelectedArray = globalState.multuGroupSelectedArray;
  let setMultuGroupSelectedArray = globalState.setMultuGroupSelectedArray;
  let isRighdivrawerVisible = globalState.isRighdivrawerVisible;
  let setIsRighdivrawerVisible = globalState.setIsRighdivrawerVisible;
  let universalParcelDifferentiator = globalState.universalParcelDifferentiator
  let universalColorPaletteName = globalState.universalColorPaletteName
  let setLandKeySelectedKey = globalState.setLandKeySelectedKey
  let isRealmLeftClickedInfoVisible = globalState.isRealmLeftClickedInfoVisible
  let setIsRealmLeftClickedInfoVisible = globalState.setIsRealmLeftClickedInfoVisible
  let activeTab = globalState.activeTab;
  let setActiveTab = globalState.setActiveTab;
  let featureList = globalState.featureList;
  let setFeatureList = globalState.setFeatureList;
  let activeFeatureId = globalState.activeFeatureId;
  let setActiveFeatureId = globalState.setActiveFeatureId;
  let mapMetaData = globalState.mapMetaData;
  let layers = globalState.layers;
  let isYearRangeActive = globalState.isYearRangeOpen;
  let setIsYearRangeActive = globalState.setIsYearRangeOpen;
  let mapOverview = globalState.mapOverview;
  let numericSummary = globalState.numericSummary;
  let setNumericSummary = globalState.setNumericSummary;
  let keySummary = globalState.keySummary;
  let setKeySummary = globalState.setKeySummary;
  let globalStartDate = globalState.globalStartDate;
  let setGlobalStartDate = globalState.setGlobalStartDate;
  let globalEndDate = globalState.globalEndDate;
  let setGlobalEndDate = globalState.setGlobalEndDate;
  let setIsLoadingNewGeoJSONFromAnUpdate = globalState.setIsLoadingNewGeoJSONFromAnUpdate;
  let setAPIReportMessage = globalState.setAPIReportMessage;
  let showFilterFeatureDataSimpleTimeseriesModal = globalState.showFilterFeatureDataSimpleTimeseriesModal;
  let setShowFilterFeatureDataSimpleTimeseriesModal = globalState.setShowFilterFeatureDataSimpleTimeseriesModal;
  let setGlobalPolygonTransparency = globalState.setGlobalPolygonTransparency;
  let availableNumericMetrics = globalState.availableNumericMetrics;
  let setAvailableNumericMetrics = globalState.setAvailableNumericMetrics;
  let availableStringMetrics = globalState.availableStringMetrics;
  let setAvailableStringMetrics = globalState.setAvailableStringMetrics;
  let debugMode = globalState.debugMode;
  let setDebugMode = globalState.setDebugMode;
  let clickedInfoTab = globalState.clickedInfoTab;
  let setClickedInfoTab = globalState.setClickedInfoTab;

  let numericTimeAggregationMethod = globalState.numericTimeAggregationMethod;
  let setNumericTimeAggregationMethod = globalState.setNumericTimeAggregationMethod;

  let setLoadedPercentage = globalState.setLoadedPercentage;

  let LOADINGPARAM_startOfLoad = globalState.LOADINGPARAM_startOfLoad;

  // 

  let LOADINGPARAM_fetchKeyData = globalState.LOADINGPARAM_fetchKeyData;
  let setLOADINGPARAM_fetchKeyData = globalState.setLOADINGPARAM_fetchKeyData;

  let LOADINGPARAM_fetchNumericData = globalState.LOADINGPARAM_fetchNumericData;
  let setLOADINGPARAM_fetchNumericData = globalState.setLOADINGPARAM_fetchNumericData;

  let mapRef = globalRefs.mapRef;

  let IsLoadingNewGeoJSONFromAnUpdate = globalState.IsLoadingNewGeoJSONFromAnUpdate;
  let isLeftSubDrawerOpen = globalState.isLeftSubDrawerOpen;

  let singleFeatureEditMode = globalState.singleFeatureEditMode;

  const selectionColour =
    multuGroupSelectedArray?.length > 0 ? "#2964A8" : "#29645D";
  const summaryFeatureIds = multuGroupSelectedArray?.length > 0
    ? Array.from(new Set(multuGroupSelectedArray))
    : Array.from(new Set((longstandingGeoJSONRef?.current?.features || []).map((feature) => feature.skylark_id)));
  const scenarioFeatureIds = Array.from(new Set([
    ...(globalState.scenarioModelledFeatureIds || []),
    ...(globalState.SMSelectedArray || []),
  ]));
  const shouldWarnScenarioSelectionExcluded = globalState.isLeftSubDrawerOpen &&
    scenarioFeatureIds.length > 0 &&
    !scenarioFeatureIds.some((featureId) => summaryFeatureIds.includes(featureId));

  const selectionColourBackground =
    multuGroupSelectedArray?.length > 0
      ? "rgba(41, 100, 168, 0.2)"
      : "rgba(41, 100, 93, 0.2)";

  const closeClickedInfoRealm = () => {
    setClickedInfoTab("DATA");

    if (Array.isArray(multuGroupSelectedArray)) {
      multuGroupSelectedArray.forEach(skylarkId => {
        polygonCustomLayerRef.current
          .removedSkylarkIdFromsetMultuGroupSelectedArrayPoints(skylarkId);
      });
    }

    setIsRealmLeftClickedInfoVisible(false);
    setFeatureList([]);
    setActiveFeatureId(null);
  };

  // toggle drawer function

  const toggleDrawer = () => {
    setIsVisible(false);
    setIsRighdivrawerVisible(!isRighdivrawerVisible);
  };

  // STRING SLIDER REQUIREMENTS

  const maxIndex = useMemo(
    () => Math.max(0, availableDates.length - 1),
    [availableDates]
  );

  const marks = useMemo(() => {
    return availableDates.reduce((acc, y, i) => {
      const date = new Date(y);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(-2);

      acc[i] = `${day}/${month}/${year}`;

      return acc;
    }, {});
  }, [availableDates]);

  const toIsoWithOffset = (date) => {
    const d = new Date(date);
    const pad = (n) => String(n).padStart(2, '0');
    const year = d.getUTCFullYear();
    const month = pad(d.getUTCMonth() + 1);
    const day = pad(d.getUTCDate());
    const hours = pad(d.getUTCHours());
    const minutes = pad(d.getUTCMinutes());
    const seconds = pad(d.getUTCSeconds());
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+00:00`;
  };

  const getFeatureIdsToPass = () => {
    const geoJSON = longstandingGeoJSONRef.current;
    const features = geoJSON?.features;
    if (!features?.length) return null;
    if (multuGroupSelectedArray.length >= 1) {
      return Array.from(new Set(multuGroupSelectedArray));
    }
    if (multuGroupSelectedArray.length === 0) {
      return Array.from(new Set(features.map(feature => feature.skylark_id)));
    }
    return null;
  };

  const offsetDateBySeconds = (dateValue, seconds) => {
    if (!dateValue) return dateValue;
    const date = new Date(dateValue);
    date.setSeconds(date.getSeconds() + seconds);
    return date.toISOString();
  };

  useEffect(() => {
    if (debugMode) {
      console.count("🟡 NUMERIC useEffect fired");
    }
    const allParamsSet =
      numericAggregationMethod &&
      numericTimeAggregationMethod &&
      globalStartDate &&
      globalEndDate;
    if (!allParamsSet) {
      if (debugMode) {
        console.log("⛔ Numeric useEffect skipped - waiting for all parameters:", {
          numericAggregationMethod,
          numericTimeAggregationMethod,
          globalStartDate,
          globalEndDate,
        });
      }
      return;
    }
    const fetchNumericData = async () => {

      if (LOADINGPARAM_startOfLoad !== true) {
        if (debugMode) {
          console.log("⛔ Attempted to call Numeric Summary fetch after a new map is loaded but before new SelectedValue is ready");
        }
        return;
      } else {
        if (debugMode) {
          console.log("🔵 Attempted to call Numeric Summary fetch after a new map is loaded but before new SelectedValue is ready");
        }
      }

      if (selectedMetric === null || selectedMetric === "default") {
        if (debugMode) {
          console.log("⛔ A NEW MAP HAS BEEN LOADED SUCCESSFULLY BUT THIS MAP IS EMPTY OF VALUES SO MARKING OK TO REMOVE LOADING SCREEN");
          setLOADINGPARAM_fetchNumericData(true);
        }
        return;
      } else {
        if (debugMode) {
          console.log("🔵 A NEW MAP HAS BEEN LOADED SUCCESSFULLY AND THIS MAP HAS VALUES SO MARKING OK TO CONTINUE CTR SUMMARY CALL");
        }
      }

      const featureIds = getFeatureIdsToPass();
      if (!featureIds || featureIds === null) {
        if (debugMode) {
          console.log("⛔ Numeric fetch skipped - no featureIds");
        }
        return;
      }
      if (debugMode) {
        console.count("🟢 NUMERIC API call");
      }
      setIsLoadingNewGeoJSONFromAnUpdate(true);
      setAPIReportMessage("Loading New Summary Data...");
      const numericParams = {
        id: currentMapIdRef.current,
        numericMetric: selectedMetric,
        workingLocally: globalState.workingLocally,
        devDeployment: globalState.devDeployment,
        summary: globalState.summary,
        kind: "timeseries",
        method: numericAggregationMethod,
        feature_ids: featureIds,
        timeseries_from: offsetDateBySeconds(globalStartDate, -1),
        timeseries_to: offsetDateBySeconds(globalEndDate, 1),
        timeseries_average: numericTimeAggregationMethod,
        globalRefs,
        globalState,
      };
      try {
        const numericResult =
          await fetchMetricDataSummaryNumeric(numericParams);
        if (!numericResult || typeof numericResult !== 'object') {
          throw new Error('Numeric summary request returned no data');
        }
        if (debugMode) {
          const timestamp = new Date().toISOString();
          console.log(
            timestamp +
            " 🔢 Numeric Values Summary returned from API: " +
            numericResult
          );
        }
        const formattedResult = Object.fromEntries(
          Object.entries(numericResult).map(([metric, dates]) => [
            metric,
            Object.fromEntries(
              Object.entries(dates).map(([date, value]) => [
                date,
                Number(value.toFixed(6)),
              ])
            ),
          ])
        );

        setNumericSummary(formattedResult);

        setIsLoadingNewGeoJSONFromAnUpdate(false);
        setAPIReportMessage("");

        setLOADINGPARAM_fetchNumericData(true);
      } catch (err) {
        console.error("❌ Numeric API error:", err);

        setIsLoadingNewGeoJSONFromAnUpdate(false);
        setAPIReportMessage("");
      }
    };

    fetchNumericData();
  }, [
    multuGroupSelectedArray,
    numericAggregationMethod,
    numericTimeAggregationMethod,
    selectedMetric,
    globalStartDate,
    globalEndDate,
    LOADINGPARAM_startOfLoad
  ]);

  useEffect(() => {
    const allParamsSet =
      selectedKey !== "default" &&
      selectedYearEditing !== null &&
      selectedYearEditing !== undefined &&
      longstandingGeoJSONRef.current;

    if (!allParamsSet) {
      if (debugMode) {
        console.log("⛔ Key useEffect skipped - waiting for all parameters:", {
          selectedKey,
          selectedYearEditing,
          longstandingGeoJSON: longstandingGeoJSONRef.current,
        });
      }
      return;
    }

    const fetchKeyData = async () => {

      if (LOADINGPARAM_startOfLoad !== true) {
        if (debugMode) {
          console.log("⛔ Attempted to call Key Summary fetch after a new map is loaded but BEFORE new SelectedKey is ready");
        }
        return;
      } else {
        if (debugMode) {
          console.log("🔵 Attempted to call Key Summary fetch after a new map is loaded AFTER new SelectedKey is ready");
        }
      }

      if (selectedKey === null || selectedKey === "default") {
        if (debugMode) {
          console.log("⛔ A NEW MAP HAS BEEN LOADED SUCCESSFULLY BUT THIS MAP IS EMPTY OF CATEGORIES SO MARKING OK TO REMOVE LOADING SCREEN");
        }
        setLOADINGPARAM_fetchKeyData(true);
        return;
      } else {
        if (debugMode) {
          console.log("🔵 A NEW MAP HAS BEEN LOADED SUCCESSFULLY AND THIS MAP HAS CATEGORIES SO MARKING OK TO CONTINUE CTR SUMMARY CALL");
        }
      }

      const featureIds = getFeatureIdsToPass();

      if (!featureIds || featureIds === null) {
        if (debugMode) {
          console.log("⛔ Key fetch skipped - no featureIds");
        }
        return;
      }

      if (debugMode) {
        console.count("🟢 KEY API call");
      }

      setIsLoadingNewGeoJSONFromAnUpdate(true);
      setAPIReportMessage("Loading New Category Summary Data...");

      const keyParams = {
        id: currentMapIdRef.current,
        keyMetric: selectedKey,
        workingLocally: globalState.workingLocally,
        devDeployment: globalState.devDeployment,
        summary: globalState.summary,
        kind: "timeseries",
        method: "count_grouped",
        feature_ids: featureIds,
        timeseries_at: selectedYearEditing,
        globalRefs,
        globalState,
      };

      try {
        const keyResult = await fetchMetricDataSummaryKey(keyParams);
        if (!keyResult || typeof keyResult !== 'object') {
          throw new Error('Key summary request returned no data');
        }

        if (debugMode) {
          const timestamp = new Date().toISOString();

          console.log(
            timestamp +
            " " +
            "🈂️ String Values Summary returned from API: " +
            keyResult
          );
        }

        setKeySummary(keyResult);

        setIsLoadingNewGeoJSONFromAnUpdate(false);
        setAPIReportMessage("");

        setLOADINGPARAM_fetchKeyData(true);
      } catch (err) {
        console.error("Key fetch error:", err);

        setIsLoadingNewGeoJSONFromAnUpdate(false);
        setAPIReportMessage("");
      }
    };

    fetchKeyData();
  }, [
    multuGroupSelectedArray,
    selectedKey,
    selectedYearEditing,
    longstandingGeoJSONRef.current,
    LOADINGPARAM_startOfLoad
  ]);

  useEffect(() => {
    if (polygonCustomLayerRef.current) {
      if (greoupingSelected) {
        polygonCustomLayerRef.current.greoupingSelectedExternalSet(true)
      } else {
        polygonCustomLayerRef.current.greoupingSelectedExternalSet(false)
      }
    }
  }, [greoupingSelected, polygonCustomLayerRef])

  function roundToTwoDecimals(value) {
    return typeof value === 'number' ? Math.round(value * 100) / 100 : value;
  }

  // useEffect(() => {
  //   if (polygonCustomLayerRef.current) {
  //     if (!isRighdivrawerVisible) {
  //       polygonCustomLayerRef.current.multiLayerSelectedExternalSet(false);
  //       polygonCustomLayerRef.current.greoupingSelectedExternalSet(false);
  //       polygonCustomLayerRef.current.resetfeatureOpacities(fmesh);
  //       multuGroupSelectedArray.length = 0;
  //       multuLayerSelectedArray.length = 0;
  //       setMultuGroupSelectedArray([]);
  //       setMultuLayerSelectedArray([]);
  //       setMoreThenOneLayer(false);
  //       if (Array.isArray(multuGroupSelectedArray)) {
  //         multuGroupSelectedArray.forEach(skylarkId => {
  //           polygonCustomLayerRef.current
  //             .removedSkylarkIdFromsetMultuGroupSelectedArrayPoints(skylarkId);
  //         });
  //       }
  //       setIsRealmLeftClickedInfoVisible(false);
  //       setFeatureList([]);
  //       setActiveFeatureId(null);
  //     }
  //   }
  // }, [isRighdivrawerVisible, polygonCustomLayerRef]);

  useEffect(() => {
    if (multuGroupSelectedArray) {
      if (multuGroupSelectedArray.length > 1) {
        setMoreThenOnePolygonSelected(false)
      } else {
        setMoreThenOnePolygonSelected(true)
      }
    }
  }, [multuGroupSelectedArray])

  useEffect(() => {
    if (layers.length > 0) {
      setMoreThenOneLayer(true);
    } else {
      setMoreThenOneLayer(false);
    }
  }, [layers])

  // SET SELECTED CATEGORY OR VALUE BASED ON VALIDATION & ORDER

  // SET SELECTED CATEGORY OR VALUE BASED ON VALIDATION & ORDER

  useEffect(() => {
    const orderedNumericMetrics =
      getOrderedVisibleMetrics(availableNumericMetrics);

    const orderedStringMetrics =
      getOrderedVisibleMetrics(availableStringMetrics);

    // Numeric / Values
    if (orderedNumericMetrics.length > 0) {
      const currentNumericIsValid =
        selectedMetric &&
        orderedNumericMetrics.includes(selectedMetric);

      if (!currentNumericIsValid) {
        const nextNumericMetric = orderedNumericMetrics[0];

        setSelectedMetric(nextNumericMetric);
        setOpenNumericMetric(nextNumericMetric);
      }
    } else {
      setSelectedMetric(null);
      setOpenNumericMetric(null);
    }

    // String / Categories
    if (orderedStringMetrics.length > 0) {
      const currentStringIsValid =
        selectedKey &&
        orderedStringMetrics.includes(selectedKey);

      if (!currentStringIsValid) {
        const nextStringMetric = orderedStringMetrics[0];

        setSelectedKey(nextStringMetric);
        setLandKeySelectedKey(nextStringMetric);
        setOpenStringMetric(nextStringMetric);
      }
    } else {
      setSelectedKey(null);
      setOpenStringMetric(null);
    }
  }, [
    availableNumericMetrics,
    availableStringMetrics,
    mapMetaData
  ]);

  useEffect(() => {
    if (selectedMetric) setOpenNumericMetric(selectedMetric);
  }, [selectedMetric]);

  useEffect(() => {
    if (selectedKey) setOpenStringMetric(selectedKey);
  }, [selectedKey]);

  useEffect(() => {
    if (!selectedMetric) return;
    const ctx = document.getElementById("totalMetricLineChart")?.getContext("2d");
    if (!ctx) return;
    if (totalLineChartRef.current) {
      totalLineChartRef.current.destroy();
    }
    const amendedSeries = numericSummary?.[selectedMetric] || {};
    const originalSeries = keySummary?.[selectedMetric] || {};

    const years = Object.keys(amendedSeries).sort();

    const amendedData = years.map(y => amendedSeries[y]);
    const originalData = years.map(y => originalSeries[y] ?? 0);
    totalLineChartRef.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: years,
        datasets: [
          {
            label: "Original",
            data: originalData,
            borderColor: "#808080",
            backgroundColor: "rgba(128,128,128,0.2)",
            tension: 0.2
          },
          {
            label: "Amended",
            data: amendedData,
            borderColor: selectionColour,
            backgroundColor: "rgba(41,100,93,0.2)",
            tension: 0.2
          }
        ]
      },
      options: {
        animation: false,
        responsive: true,
        plugins: {
          legend: { display: true }
        },
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  }, [selectedMetric, longstandingGeoJSONRef, originalGeoJSONforComparingRef, selectedYearEditing]);

  const tabIcons = {
    TOTAL: <MdOutlineAddToPhotos />,
    GROUP: <CgMenuGridO />,
    MULTILAYER: <MdOutlineLayers />
  };

  const convertCoordinates = (geometry) => {
    if (geometry.type === 'Point') return geometry.coordinates;
    if (geometry.type === 'Polygon') return [geometry.coordinates[0].map((coord) => [coord[0], coord[1]])];
    if (geometry.type === 'MultiPolygon') return geometry.coordinates.map((poly) => [poly[0].map((coord) => [coord[0], coord[1]])]);
    throw new Error(`Unsupported geometry type: ${geometry.type}`);
  };
  const selectedKeyRef = useRef(selectedKey);
  const selectedNumericRef = useRef(selectedMetric);

  useEffect(() => {
    selectedKeyRef.current = selectedKey;
  }, [selectedKey]);

  useEffect(() => {
    selectedNumericRef.current = selectedMetric;
  }, [selectedMetric]);

  const handleMetricClick = async ({ metric, isNumeric }) => {
    if (isNumeric) {
      setSelectedMetric(metric);
    } else {
      setSelectedKey(metric);
      setLandKeySelectedKey(metric);
    };
  };

  if (!longstandingGeoJSONRef.current) {
    noData = true;
  } else {
    noData = false;
  }

  const [openNumericMetric, setOpenNumericMetric] = useState(null);
  const [openStringMetric, setOpenStringMetric] = useState(null);

  // TODO

  useEffect(() => {
    if (!multuGroupSelectedArray || !Array.isArray(multuGroupSelectedArray) || !longstandingGeoJSONRef.current || !originalGeoJSONforComparingRef.current || longstandingGeoJSONRef.current.features.length === 0) return;
    if (multuGroupSelectedArray.length === 1) {
      setActiveTab("GROUP");
    } else {
      setActiveTab("TOTAL");
    }
    if (multuGroupSelectedArray.length === 0) {
      setClickedInfoTab("DATA")
      polygonCustomLayerRef.current?.resetfeatureOpacities(fmesh);
    }
  }, [multuGroupSelectedArray, longstandingGeoJSONRef.current, originalGeoJSONforComparingRef.current]);

  // INFO SECTION

  useEffect(() => {
    if (multuGroupSelectedArray.length > 1) {
      setClickedInfoTab("DATA");
    }
  }, [multuGroupSelectedArray]);

  // 

  const getOrderedVisibleMetrics = (metrics) => {
    const metadata =
      mapMetaData?.define_feature_data_simple_timeseries || {};

    return [...metrics]
      .filter((metric) => {
        const meta = metadata[metric];

        return meta?.display_by_default === true;
      })
      .sort((a, b) => {
        const metaA = metadata[a] || {};
        const metaB = metadata[b] || {};

        const orderA =
          typeof metaA.display_order === 'number'
            ? metaA.display_order
            : Number.MAX_SAFE_INTEGER;

        const orderB =
          typeof metaB.display_order === 'number'
            ? metaB.display_order
            : Number.MAX_SAFE_INTEGER;

        // Primary sort: display_order
        if (orderA !== orderB) {
          return orderA - orderB;
        }

        // Secondary sort: property name
        const nameA = metaA.name || a;
        const nameB = metaB.name || b;

        return nameA.localeCompare(nameB, undefined, {
          sensitivity: 'base',
          numeric: true
        });
      });
  };

  const orangeColor = "#c97b06";

  useEffect(() => {
    if (!singleFeatureEditMode && clickedInfoTab === "INFO") {
      setClickedInfoTab("DATA");
    }
  }, [clickedInfoTab, singleFeatureEditMode]);

  return (
    <>
      <button className="togglerRightDrawInside" onClick={toggleDrawer}>
        <IoIosArrowBack />
      </button>

      <Drawer
        open={isRighdivrawerVisible}
        direction="right"
        className="rightSubMenu"
        enableOverlay={false}
        duration={250}
      >
        <div
          style={{
            display: "flex",
            marginTop: "125px",
            marginLeft: "10px",
            marginRight: "10px",
            border: singleFeatureEditMode && multuGroupSelectedArray.length !== 0
              ? "1px solid #c97b06"
              : "1px solid transparent",
            borderRadius: "3px",
            overflow: "hidden",
          }}
        >
          {singleFeatureEditMode && (
            <>
              {multuGroupSelectedArray.length === 0 ? (
                null
              ) : (
                <>
                  <button
                    onClick={() => setClickedInfoTab("DATA")}
                    style={{
                      flex: 1,
                      padding: "5px",
                      border: "none",
                      background:
                        clickedInfoTab === "DATA" ? "#c97b06" : "#F5E8D2",
                      color:
                        clickedInfoTab === "DATA" ? "#fff" : "#c97b06",
                      fontWeight: "bold",
                      fontSize: "16px"
                    }}
                  >
                    <MdBarChart />
                  </button>

                  <button
                    onClick={() => setClickedInfoTab("INFO")}
                    style={{
                      flex: 1,
                      padding: "5px",
                      border: "none",
                      background:
                        clickedInfoTab === "INFO" ? "#c97b06" : "#F5E8D2",
                      color:
                        clickedInfoTab === "INFO" ? "#fff" : "#c97b06",
                      fontWeight: "bold",
                      fontSize: "16px"
                    }}
                  >
                    <IoIosInformationCircleOutline />
                  </button>

                  <button
                    onClick={() => setClickedInfoTab("FILES")}
                    style={{
                      flex: 1,
                      padding: "5px",
                      border: "none",
                      background:
                        clickedInfoTab === "FILES" ? "#c97b06" : "#F5E8D2",
                      color:
                        clickedInfoTab === "FILES" ? "#fff" : "#c97b06",
                      fontWeight: "bold",
                      fontSize: "16px"
                    }}
                  >
                    <FaRegFileImage />
                  </button>

                  <button
                    onClick={() => setClickedInfoTab("NOTES")}
                    style={{
                      flex: 1,
                      padding: "5px",
                      border: "none",
                      background:
                        clickedInfoTab === "NOTES" ? "#c97b06" : "#F5E8D2",
                      color:
                        clickedInfoTab === "NOTES" ? "#fff" : orangeColor,
                      fontWeight: "bold",
                      fontSize: "16px"
                    }}
                  >
                    <CgNotes />
                  </button>
                </>
              )}
            </>
          )}
        </div>

        {/* INFO TAB */}

        {multuGroupSelectedArray.length < 2 && singleFeatureEditMode && (
          <>
            {clickedInfoTab === "INFO" &&
              multuGroupSelectedArray.length < 2 && (
                <div
                  style={{
                    height: "calc(100% - 220px)",
                    marginTop: "10px",
                    overflow: "scroll",
                  }}
                >
                  <MapMetaOrFeatureDataSimple
                    multuGroupSelectedArray={multuGroupSelectedArray}
                    mapOverview={mapOverview}
                    longstandingGeoJSONRef={longstandingGeoJSONRef}
                    globalState={globalState}
                  />
                </div>
              )}
          </>
        )}

        {/* DATA TAB */}

        {!singleFeatureEditMode && (
          <YearDropdown
            selectedMetric={selectedMetric}
            isModifying={isModifying}
            selectedYearEditing={selectedYearEditing}
            globalState={globalState}
            globalRefs={globalRefs}
            setSelectedYearEditing={setSelectedYearEditing}
            ResetMap={ResetMap}
          />
        )}

        {clickedInfoTab === "DATA" && (
          <div
            className="clicked_info"
            ref={TotalsRef}
            style={{
              height:
                multuGroupSelectedArray.length < 2
                  ? "calc(100% - 140px)"
                  : "calc(100% - 140px)"
            }}
          >
            <BrowserView>

              {singleFeatureEditMode ? (
                <>
                  {
                    multuGroupSelectedArray.length === 0 ? (
                      <div
                        style={{
                          marginTop: '40vh',
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          padding: "30px",
                          textAlign: "center",
                          color: "#A9A8AA",
                        }}
                      >
                        Select a feature to begin Feature Inspection
                      </div>
                    ) : (
                      <div className='clicked_info_inner'>
                        <ClickedInfoRealm
                          longstandingGeoJSONRef={longstandingGeoJSONRef}
                          universalParcelDifferentiator={
                            universalParcelDifferentiator
                          }
                          universalColorPaletteName={
                            universalColorPaletteName
                          }
                          landKeySelectedKey={landKeySelectedKey}
                          setLandKeySelectedKey={setLandKeySelectedKey}
                          globalState={globalState}
                          globalRefs={globalRefs}
                          isRealmLeftClickedInfoVisible={
                            isRealmLeftClickedInfoVisible
                          }
                          setIsRealmLeftClickedInfoVisible={
                            setIsRealmLeftClickedInfoVisible
                          }
                          selectedYearEditing={selectedYearEditing}
                          ResetMap={ResetMap}
                          polygonCustomLayerRef={polygonCustomLayerRef}
                          featureList={featureList}
                          setFeatureList={setFeatureList}
                          activeFeatureId={activeFeatureId}
                          setActiveFeatureId={setActiveFeatureId}
                        />
                      </div>
                    )
                  }
                </>
              ) : (

                <div className="clicked_info_inner" style={{ paddingTop: "125px", paddingRight: "10px" }}>
                  <b style={{ fontSize: '14px' }}>
                    Summarising {" "}
                    {(multuGroupSelectedArray?.length ?? 0) === 0
                      ? "all " + longstandingGeoJSONRef.current?.features.length
                      : multuGroupSelectedArray.length}{" "}
                    Features
                  </b>

                  <button
                    style={{
                      backgroundColor: '#fff',
                      border: `1px solid ${selectionColour}`,
                      color: selectionColour,
                      paddingTop: '5px',
                      paddingBottom: '5px',
                      width: '55px',
                      borderRadius: '3px',
                      fontSize: '10px',
                      float: 'right'
                    }}
                    onClick={() => setShowFilterFeatureDataSimpleTimeseriesModal(true)}
                  >
                    <IoFilter />
                  </button>

                  <br />
                  <br />

                  <div style={{
                    width: '100%',
                    backgroundColor: selectionColour,
                    height: '1px',
                  }}></div>

                  {/* NUMERIC METRICS */}
                  <div style={{ marginBottom: "10px", marginTop: '13px' }}>

                    <div
                      className="setNumericAggregationMethod"
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        height: '20px',
                        width: '70%',
                        position: 'relative',
                        top: '-5px',
                        right: '0px',
                        float: 'right'
                      }}
                    >

                      <div
                        style={{
                          position: 'relative',
                          display: 'flex',
                          gap: '6px',
                          alignItems: 'center'
                        }}
                      >
                        <button
                          style={{
                            backgroundColor:
                              numericAggregationMethod === 'avg' ? selectionColour : '#fff',
                            border: `1px solid ${selectionColour}`,
                            color:
                              numericAggregationMethod === 'avg' ? '#fff' : selectionColour,
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            width: '55px',
                            borderRadius: '3px',
                            fontSize: '10px'
                          }}
                          onClick={() => setNumericAggregationMethod('avg')}
                        >
                          Avg
                        </button>

                        <button
                          style={{
                            backgroundColor:
                              numericAggregationMethod === 'sum' ? selectionColour : '#fff',
                            border: `1px solid ${selectionColour}`,
                            color:
                              numericAggregationMethod === 'sum' ? '#fff' : selectionColour,
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            width: '55px',
                            borderRadius: '3px',
                            fontSize: '10px'
                          }}
                          onClick={() => setNumericAggregationMethod('sum')}
                        >
                          Sum
                        </button>

                        <button
                          style={{
                            backgroundColor:
                              numericAggregationMethod === 'avg_by_area' ? selectionColour : '#fff',
                            border: `1px solid ${selectionColour}`,
                            color:
                              numericAggregationMethod === 'avg_by_area' ? '#fff' : selectionColour,
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            width: '55px',
                            borderRadius: '3px',
                            fontSize: '10px'
                          }}
                          onClick={() => setNumericAggregationMethod('avg_by_area')}
                        >
                          Area Avg
                        </button>

                        {/* <IoIosArrowDown
                          style={{
                            position: 'absolute',
                            right: '6px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#29645D',
                            fontSize: '12px',
                            pointerEvents: 'none'
                          }}
                        /> */}
                      </div>
                    </div>

                    <p style={{
                      fontSize: '9px',
                      fontWeight: 'bold',
                      color: selectionColour,
                      marginBottom: '12px'
                    }}>
                      Values
                    </p>

                    {shouldWarnScenarioSelectionExcluded && (
                      <p role="status" style={{ margin: "0 0 8px", padding: "6px 8px", borderLeft: "3px solid #D63384", background: "#FFF1F7", color: "#8E285C", fontSize: 11 }}>
                        Summary data does not include any features in the Scenario Modelling selection.
                      </p>
                    )}

                    {getOrderedVisibleMetrics(availableNumericMetrics)
                      .map((metric) => {
                        const isOpen = openNumericMetric === metric;

                        const rawMeta =
                          mapMetaData?.define_feature_data_simple_timeseries?.[metric] || {};

                        const meta = {
                          ...rawMeta,
                          display_hint: rawMeta.display_hint ?? "chartdata_line",
                        };

                        return (
                          <MetricItem
                            key={metric}
                            metric={metric}
                            isNumeric={true}
                            isOpen={isOpen}
                            meta={meta}
                            setOpenNumericMetric={setOpenNumericMetric}
                            handleMetricClick={handleMetricClick}
                            selectedMetric={selectedMetric}
                            selectedKey={selectedKey}
                            numericSummary={numericSummary}
                            keySummary={keySummary}
                            selectedYearEditing={selectedYearEditing}
                            selectedRange={selectedRange}
                            setSelectedYearEditing={setSelectedYearEditing}
                            availableDates={availableDates}
                            marks={marks}
                            toIsoWithOffset={toIsoWithOffset}
                            numericTimeAggregationMethod={numericTimeAggregationMethod}
                            scenarioModels={globalState.scenarioModels || []}
                            scenarioModelingActive={globalState.scenarioModelingModeActive}
                            longstandingGeoJSONRef={longstandingGeoJSONRef}
                            IsLoadingNewGeoJSONFromAnUpdate={IsLoadingNewGeoJSONFromAnUpdate}
                            multuGroupSelectedArray={multuGroupSelectedArray}
                          />
                        );
                      })}
                  </div>

                  {/* CATEGORY METRICS */}
                  <div>

                    <div
                      className="setNumericAggregationMethod"
                      style={{
                        display: 'flex',
                        height: '20px',
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        position: 'relative',
                        top: '-5px',
                        float: 'right'
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: selectionColour,
                          border: selectionColour,
                          color: '#fff',
                          paddingTop: '5px',
                          paddingBottom: '5px',
                          width: '55px',
                          borderRadius: '3px',
                          fontSize: '10px'
                        }}
                      >
                        Sum
                      </button>
                    </div>

                    <p style={{
                      fontSize: '9px',
                      fontWeight: 'bold',
                      color: selectionColour,
                      margin: '5px 0px 10px 0px',
                    }}>
                      Categories
                    </p>

                    {getOrderedVisibleMetrics(availableStringMetrics)
                      .map((metric) => {
                        const isOpen = openStringMetric === metric;

                        const rawMeta =
                          mapMetaData?.define_feature_data_simple_timeseries?.[metric] || {};

                        const meta = {
                          ...rawMeta,
                          display_hint: rawMeta.display_hint ?? null,
                        };

                        return (
                          <MetricItem
                            key={metric}
                            metric={metric}
                            isNumeric={false}
                            isOpen={isOpen}
                            meta={meta}
                            setOpenStringMetric={setOpenStringMetric}
                            handleMetricClick={handleMetricClick}
                            selectedMetric={selectedMetric}
                            selectedKey={selectedKey}
                            numericSummary={numericSummary}
                            keySummary={keySummary}
                            selectedYearEditing={selectedYearEditing}
                            setSelectedYearEditing={setSelectedYearEditing}
                            availableDates={availableDates}
                            marks={marks}
                            toIsoWithOffset={toIsoWithOffset}
                            scenarioModels={globalState.scenarioModels || []}
                            scenarioModelingActive={globalState.scenarioModelingModeActive}
                            numericTimeAggregationMethod={numericTimeAggregationMethod}
                            longstandingGeoJSONRef={longstandingGeoJSONRef}
                            polygonCustomLayerRef={polygonCustomLayerRef}
                            multuGroupSelectedArray={multuGroupSelectedArray}
                            setMultuGroupSelectedArray={setMultuGroupSelectedArray}
                            setGlobalPolygonTransparency={setGlobalPolygonTransparency}
                            IsLoadingNewGeoJSONFromAnUpdate={IsLoadingNewGeoJSONFromAnUpdate}
                          />
                        );
                      })}
                  </div>

                </div>
              )
              }

              {/* {activeTab === "GROUP" && (
                <div className='clicked_info_inner'>
                  {multuGroupSelectedArray.length === 1 ? (
                    <>
                      <ClickedInfoRealm
                        longstandingGeoJSONRef={longstandingGeoJSONRef}
                        universalParcelDifferentiator={
                          universalParcelDifferentiator
                        }
                        universalColorPaletteName={
                          universalColorPaletteName
                        }
                        landKeySelectedKey={landKeySelectedKey}
                        setLandKeySelectedKey={setLandKeySelectedKey}
                        globalState={globalState}
                        globalRefs={globalRefs}
                        isRealmLeftClickedInfoVisible={
                          isRealmLeftClickedInfoVisible
                        }
                        setIsRealmLeftClickedInfoVisible={
                          setIsRealmLeftClickedInfoVisible
                        }
                        selectedYearEditing={selectedYearEditing}
                        ResetMap={ResetMap}
                        polygonCustomLayerRef={polygonCustomLayerRef}
                        featureList={featureList}
                        setFeatureList={setFeatureList}
                        activeFeatureId={activeFeatureId}
                        setActiveFeatureId={setActiveFeatureId}
                      />
                    </>
                  ) : (
                    <>
                      <div className="clicked_info_inner_inner" >

                        <div style={{
                          paddingTop: '220px',
                          paddingLeft: '10px',
                          width: 'calc(100% - 21px)',
                          height: '118px',
                        }} >
                          Please Select a Parcel to begin viewing Group information
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )} */}
            </BrowserView>
          </div >
        )}

        {/* FILES TAB */}

        {
          clickedInfoTab === "FILES" && (
            <div
              style={{
                padding: "20px",
                color: selectionColour,
                fontWeight: "bold",
                textAlign: "center",
                marginTop: "40px"
              }}
            >
              <span style={{
                border: '1px solid #222',
                padding: '10px',
                borderRadius: '3px',
                // backgroundColor: 'rgb(222, 239, 231)'
              }}>Files Feature Currently in development
              </span>
            </div>
          )
        }

        {/* NOTES TAB */}

        {
          clickedInfoTab === "NOTES" && (
            <div
              style={{
                padding: "20px",
                color: selectionColour,
                fontWeight: "bold",
                textAlign: "center",
                marginTop: "40px"
              }}
            >
              <span style={{
                border: '1px solid #222',
                padding: '10px',
                borderRadius: '3px',
                // backgroundColor: 'rgb(222, 239, 231)'
              }}>Notes Feature Currently in development
              </span>
            </div>
          )
        }

        <button className='togglerRightDrawOutside' onClick={toggleDrawer}>
          <IoIosArrowForward />
        </button>

        {/* {!isLeftSubDrawerOpen ? (
          <div
            style={{
              backgroundColor: '#fff',
              height: '110px',
              zIndex: '1000000',
              width: '100%',
              position: 'absolute',
              bottom: '0px'
            }}
          >
            <button
              style={{
                position: 'relative',
                paddingTop: '10px',
                paddingLeft: '20px',
                left: '50%',
                top: '10px',
                transform: 'translateX(-50%)',
                paddingRight: '20px',
                color: '#fff',
                paddingBottom: '10px',
                borderRadius: '3px',
                zIndex: 10,
                textAlign: 'center',
                margin: '0px 10px',
                backgroundColor: multuGroupSelectedArray.length > 0
                  ? 'black'
                  : '#E6E4ED',
                cursor: multuGroupSelectedArray.length > 0
                  ? 'pointer'
                  : 'not-allowed',
                pointerEvents: multuGroupSelectedArray.length > 0
                  ? 'auto'
                  : 'none',
              }}
              onClick={closeClickedInfoRealm}
            >
              Empty Selection
            </button>
          </div>
        ) : (
          null
        )
        } */}

      </Drawer >
    </>

  );
};

export default ClickedInfo;
